// This function allow to reference all chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === "main") return "static/js/bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + ".chunk.js";
};